import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import Home from './pages/Home';
import CreateHub from './pages/CreateHub';
import CreateToken from './pages/CreateToken';
import MyTokens from './pages/MyTokens';
import TokenDetail from './pages/TokenDetail';
import EditToken from './pages/EditToken';
import NFTs from './pages/NFTs';
import NftCollection from './pages/NftCollection';
import Presales from './pages/Presales';
import PresaleDetail from './pages/PresaleDetail';
import MultiToken from './pages/MultiToken';
import MultiTokenCollection from './pages/MultiTokenCollection';
import Guide from './pages/Guide';
import VipStudio from './pages/VipStudio';
import Tools from './pages/Tools';
import TokensGuide from './pages/guide/TokensGuide';
import VipsGuide from './pages/guide/VipsGuide';
import DeployGuide from './pages/guide/DeployGuide';
import NftsGuide from './pages/guide/NftsGuide';
import PresalesGuide from './pages/guide/PresalesGuide';

function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'bg-vextaris-dark text-white',
          duration: 4000,
        }}
      />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<CreateHub />} />
          <Route path="/create/token" element={<CreateToken />} />
          <Route path="/my-tokens" element={<MyTokens />} />
          <Route path="/token/:mint" element={<TokenDetail />} />
          <Route path="/token/:mint/edit" element={<EditToken />} />
          <Route path="/nfts" element={<NFTs />} />
          <Route path="/nft/:collection" element={<NftCollection />} />
          <Route path="/presales" element={<Presales />} />
          <Route path="/presale/:mint" element={<PresaleDetail />} />
          <Route path="/multi-token" element={<MultiToken />} />
          <Route path="/multi-token/:collection" element={<MultiTokenCollection />} />
          <Route path="/programs" element={<VipStudio />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/guide/tokens" element={<TokensGuide />} />
          <Route path="/guide/vips" element={<VipsGuide />} />
          <Route path="/guide/deploy" element={<DeployGuide />} />
          <Route path="/guide/nfts" element={<NftsGuide />} />
          <Route path="/guide/presales" element={<PresalesGuide />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
